import { use, useState } from 'react';

import type { IconButtonProps } from '@mui/material';
import { IconButton, Popover } from '@mui/material';
import type { Editor } from '@tiptap/core';
import { EmojiEmotionsOutlined } from '@mui/icons-material';
import { EmojiStyle } from 'emoji-picker-react';

import { EmojiPickerContext } from '@/modules/editor/contexts/EmojiPickerContext';
interface Props extends IconButtonProps {
  editor: Editor;
}

export const PostCommentEmojiButton = ({ editor, ...other }: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const EmojiPicker = use(EmojiPickerContext);

  const open = Boolean(anchorEl);
  const id = open ? 'emoji-popover' : undefined;

  return (
    <>
      <IconButton
        {...other}
        aria-describedby={id}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <EmojiEmotionsOutlined />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <EmojiPicker
          emojiStyle={EmojiStyle.NATIVE}
          onEmojiClick={(emoji) =>
            editor.chain().focus().insertContent(emoji.emoji).run()
          }
        />
      </Popover>
    </>
  );
};
